module.exports = __webpack_public_path__ + "img/lens-167-plus-06.4d418b33.png";